import { useMutation } from "@enkor/react-query";

import BaseApi from "@logics/api/baseApi";
import useModalState from "@logics/hooks/useModalState";
import { RequestCreateServiceReport } from "@models/data-contracts";

const serviceApi = new BaseApi("/service");

// ------------------------------------------------------------------------

export const useCreateReportMutation = () => {
  const { closeModal } = useModalState();

  return useMutation({
    mutationFn: (body: RequestCreateServiceReport) =>
      serviceApi.post("/report", body),
    onSuccess: () => {
      closeModal();
    },
  });
};
